import { FC, useState, useEffect } from 'react';
import { Form, FormProps } from '../../../../lib/components';

export type ProfileFormProps = FormProps & { onStateChanged?: (state: boolean) => void };

export const ProfileForm: FC<ProfileFormProps> = (props) => {
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [isValid, setIsValid] = useState<boolean>(false);
  const canSubmit = isDirty && isValid;

  const handleDirtyChanged = (dirty: boolean) => {
    setIsDirty(dirty);
    props.onDirtyChanged?.(dirty);
  };

  const handleValidityChanged = (valid: boolean) => {
    setIsValid(valid);
    props.onValidityChanged?.(valid);
  };

  useEffect(() => {
    props.onStateChanged?.(canSubmit);
  }, [canSubmit]);

  return (
    <Form
      {...props}
      useCustomButton
      enableReinitialize
      onDirtyChanged={handleDirtyChanged}
      onValidityChanged={handleValidityChanged}
    >
      {props.children}
    </Form>
  );
};
